<template>
  <v-app style="text-align: center">
    <v-container>
      <h1>{{ $t("datos_registro") }}</h1>
      <v-row justify="center" class="fill-height">
        <v-col>
          <v-form @submit.prevent="send">
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  :items="languages"
                  item-text="nombre"
                  item-value="clave"
                  v-model="form.lenguaje"
                  :label="$t('lenguaje')"
                  @change="changeLanguage"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field :label="$t('nombre')" v-model="form.nombre" />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="form.identificacion_tributaria"
                  :label="$t('identificacion_tributaria')"
              /></v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="form.contacto" :label="$t('contacto')" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="form.direccion" :label="$t('direccion')"
              /></v-col>
              <v-col cols="4">
                <v-text-field
                  type="number"
                  v-model="form.dias_credito"
                  :label="$t('dias_credito')"
              /></v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="form.telefono" :label="$t('telefono')" />
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  :items="countries"
                  item-text="nombre"
                  item-value="id"
                  v-model="form.pais_id"
                  :label="$t('pais')"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  type="password"
                  v-model="form.password"
                  :label="$t('contrasena')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-autocomplete
                  :items="banks"
                  item-text="nombre"
                  item-value="id"
                  v-model="form.banco_id"
                  :label="$t('banco')"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field :label="$t('cuenta')" v-model="form.cuenta" />
              </v-col>
              <v-col cols="4">
                <v-text-field :label="$t('clabe')" v-model="form.clabe" />
              </v-col>
              <v-col cols="4">
                <v-text-field :label="$t('swift')" v-model="form.swift" />
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  :items="generalDocs"
                  item-text="nombre"
                  item-value="id"
                  v-model="form.origen_id"
                  :label="$t('documentacion')"
                  @change="getOriginDocumentation"
                />
              </v-col>
            </v-row>
            <v-divider />
            <h1>{{ $t("documentacion") }}</h1>
            <v-row>
              <v-col cols="3" v-for="(doc, index) of docs" :key="index">
                <v-file-input
                  :label="doc[`nombre_${$root.$i18n.locale}`]"
                  accept="application/pdf"
                  v-model="providerDocs[doc.id]"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-fab-transition>
      <v-btn fab fixed bottom right color="blue" @click="save">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-app>
</template>

<script>
export default {
  name: "FinalRegister",
  data() {
    return {
      form: {
        lenguaje: window.localStorage.lenguaje || "es",
        codigo: this.$route.params.code,
      },
      countries: [],
      languages: [],
      docs: [],
      banks: [],
      generalDocs: [],
      providerDocs: {},
    };
  },
  methods: {
    changeLanguage() {
      window.localStorage.lenguaje = this.form.lenguaje;
      this.$root.$i18n.locale = this.form.lenguaje;
      this.getGeneralDocumentation();
    },
    getLanguages() {
      this.openLoader();
      const languagesURL = `${this.$store.state.proveedorUrl}catalogos/idiomas`;
      const languagesRequest = this.sendRequest(languagesURL);
      languagesRequest.then(({ data }) => {
        this.languages = data;
      });
    },
    getCountries() {
      const countriesURL = `${this.$store.state.proveedorUrl}catalogos/paises`;
      const countriesRequest = this.sendRequest(countriesURL);
      countriesRequest.then(({ data }) => {
        this.countries = data;
      });
    },
    getGeneralDocumentation() {
      const generalDocURL = `${this.$store.state.proveedorUrl}catalogos/documentacion`;
      const generalDocParams = { idioma: this.$root.$i18n.locale };
      const request = this.sendRequest(generalDocURL, generalDocParams);
      request
        .then(({ data }) => {
          this.generalDocs = data;
        })
        .finally(this.closeLoader);
    },
    async getBanks() {
      const banksURL = `${this.$store.state.proveedorUrl}catalogos/bancos`;
      const { data } = await this.sendRequest(banksURL);
      this.banks = data;
    },
    getOriginDocumentation() {
      const originDocURL = `${this.$store.state.proveedorUrl}catalogos/documentacion/${this.form.origen_id}/documentos`;
      const originDocParams = { idioma: this.$root.$i18n.locale };
      const request = this.sendRequest(originDocURL, originDocParams);
      request
        .then(({ data }) => {
          this.docs = data;
          this.docs.forEach((doc) => (this.providerDocs[doc.id] = {}));
        })
        .finally(this.closeLoader);
    },
    async save() {
      this.openLoader();
      const registerURL = `${this.$store.state.proveedorUrl}finish-registration`;

      let form = new FormData();
      Object.keys(this.form).map((k) => form.append(k, this.form[k]));
      if (Object.keys(this.providerDocs).length) {
        Object.keys(this.providerDocs).map((k) => {
          form.append(`docs[${k}]`, this.providerDocs[k]);
        });
      }

      const registerRequest = await this.sendRequest(
        registerURL,
        form,
        "POST",
        true
      );
      if (registerRequest.success) {
        this.showSuccessMessage(registerRequest.message);
        window.setTimeout(() => (window.location = "/"), 2000);
      }
      this.closeLoader();
    },
  },
  async created() {
    const request = await this.sendRequest(
      `${this.$store.state.proveedorUrl}code-check`,
      {
        code: this.$route.params.code,
      },
      "GET"
    );
    if (request.success) {
      this.getLanguages();
      this.getCountries();
      this.getBanks();
      this.getGeneralDocumentation();
    } else {
      setTimeout(() => (window.location = "/"), 2000);
    }
  },
};
</script>